"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var r=TypeError,F=9007199254740991,o=function(e){if(e>F)throw r("Maximum allowed index exceeded");return e};exports.doesNotExceedSafeInteger=o;
